export default __webpack_public_path__ + "static/media/cs116.36a8c5e2.jpg";